import React, {Component} from 'react';
import {
  resultsTranslations
} from 'components/results-tabs/translations';

const TRANSLATIONS = {
  resultsTranslations
};

// Usage
// import withTranslations from 'hoc/withTranslations';
// const ComposedComponent = withTranslations('resultsTranslations')(OriginalComponent);

const withTranslations = (module) => (WrappedComponent) => {
  return class TranslationsComponent extends Component {
    render() {
      return (<WrappedComponent translations={TRANSLATIONS[module]} {...this.props} />);
    }
  };
};

export default withTranslations;
